import z from 'zod'
import {
  nullSafeOptionalBoolean,
  nullSafeOptionalFirestoreTimestamp,
  nullSafeOptionalString,
  nullSafeString,
} from '../shared/schema'
import { promptVersionPromptFields } from '../../types'

export const schema = z.object({
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
  minScore: z.coerce.number(),
  maxScore: z.coerce.number(),
  description: nullSafeString(''),
  title: nullSafeString(''),
  scoreDescriptions: z.preprocess(
    (val) => val ?? [],
    z.array(
      z.object({
        score: z.coerce.number(),
        title: nullSafeString(''),
        explanation: nullSafeString(''),
        prompt: nullSafeString(''),
        color: nullSafeString(''),
        textColor: nullSafeOptionalString(),
        meaning: nullSafeString(''),
      })
    )
  ),
  scoreGrouping: z
    .record(
      z.string(),
      z.object({
        color: z.string(),
        scores: z.array(z.coerce.number()),
      })
    )
    .nullish()
    .optional(),
  requiredPrompts: z.array(z.enum(promptVersionPromptFields)).default([]),
  optionalPrompts: z.array(z.enum(promptVersionPromptFields)).default([]),
  promptSchemas: z
    .record(z.enum(promptVersionPromptFields), z.string())
    .default({}),
  trigger: nullSafeOptionalString(),
  showTestingTab: nullSafeOptionalBoolean(false),
  excludeSoloExperiences: nullSafeOptionalBoolean(false),
})

export const empty = Object.freeze(
  schema.parse({
    updatedAt: null,
    minScore: 0,
    maxScore: 0,
    description: '',
    title: '',
    scoreDescriptions: [],
    requiredPrompts: [],
    optionalPrompts: [],
  })
)

export type FirestorePromptRubricType = z.infer<typeof schema>
